import dynamic from "next/dynamic";
import Header from "./organisms/common/Header";
import Footer from "./organisms/common/Footer";
import StylesProvider from "./organisms/common/StylesProvider";
const GsiOnetapWidget = dynamic(() =>
  import("@components/organisms/common/GsiOnetapWidget")
);

export default function IndustryHubTheme({
  children,
  header,
  footer,
  nonce,
  headerClassNames,
  ...props
}) {
  return (
    <StylesProvider>
      <Header data={header} headerClassNames={headerClassNames} />
      <GsiOnetapWidget nonce={nonce} />
      {/* <PromoBanner /> */}
      <main {...props}>{children}</main>
      <Footer data={footer} />
    </StylesProvider>
  );
}
